/**
 * Extract a user-facing message from an Axios/API error.
 */
export function getApiError(error, fallback = 'Something went wrong. Please try again.') {
  if (!error) return fallback;

  if (!error.response) {
    if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
      return 'Network error. Please check your connection and try again.';
    }
    return error.message || fallback;
  }

  const data = error.response.data;
  if (!data) return fallback;

  if (typeof data === 'string') return data;
  if (data.message) return data.message;
  if (data.error) return typeof data.error === 'string' ? data.error : data.error.message || fallback;
  if (Array.isArray(data.errors) && data.errors.length) {
    return data.errors.map((e) => (typeof e === 'string' ? e : e.message)).filter(Boolean).join(', ') || fallback;
  }

  return fallback;
}
